export const basePath = process.env.REACT_APP_BASE_URL || 'http://localhost:3000/api';
